import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41725780"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-container cube-preview" }
const _hoisted_2 = { class: "table is-condensed is-bordered is-striped" }
const _hoisted_3 = ["colspan"]
const _hoisted_4 = { class: "level" }
const _hoisted_5 = { class: "level-left" }
const _hoisted_6 = { class: "level-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "has-text-danger" }, "Missing cube title", -1))
const _hoisted_8 = { class: "level-item" }
const _hoisted_9 = { class: "level-right" }
const _hoisted_10 = { class: "has-background-light" }
const _hoisted_11 = {
  key: 0,
  class: "has-text-grey has-text-centered"
}
const _hoisted_12 = ["colspan"]
const _hoisted_13 = { class: "message is-warning" }
const _hoisted_14 = { class: "message-body px-2 py-1 is-flex" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["colspan"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = ["colspan"]
const _hoisted_19 = { key: 2 }
const _hoisted_20 = ["colspan"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "has-text-grey has-text-centered" }, " No observations available. Did you already run a transformation? ", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = ["colspan"]
const _hoisted_24 = { class: "is-flex is-justify-content-space-between gap-4" }
const _hoisted_25 = { class: "is-flex is-align-items-center gap-1" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-4" }, "Page", -1))
const _hoisted_27 = { class: "" }
const _hoisted_28 = { class: "ml-4" }
const _hoisted_29 = { class: "is-flex gap-2" }
const _hoisted_30 = ["native-value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_term_with_language = _resolveComponent("term-with-language")!
  const _component_hydra_operation_button = _resolveComponent("hydra-operation-button")!
  const _component_language_select = _resolveComponent("language-select")!
  const _component_cube_preview_dimension = _resolveComponent("cube-preview-dimension")!
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_loading_block = _resolveComponent("loading-block")!
  const _component_b_message = _resolveComponent("b-message")!
  const _component_cube_preview_value = _resolveComponent("cube-preview-value")!
  const _component_o_button = _resolveComponent("o-button")!
  const _component_o_tooltip = _resolveComponent("o-tooltip")!
  const _component_o_input = _resolveComponent("o-input")!
  const _component_o_select = _resolveComponent("o-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", {
            colspan: _ctx.dimensions.length || 1
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_term_with_language, {
                    values: _ctx.cubeMetadata.title,
                    "selected-language": _ctx.selectedLanguage
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }, 8, ["values", "selected-language"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_hydra_operation_button, {
                    operation: _ctx.cubeMetadata.actions.edit,
                    to: { name: 'CubeMetadataEdit' }
                  }, null, 8, ["operation"])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_language_select, {
                  "selected-language": _ctx.selectedLanguage,
                  onLanguageSelected: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('selectLanguage', $event)))
                }, null, 8, ["selected-language"])
              ])
            ])
          ], 8, _hoisted_3)
        ]),
        _createElementVNode("tr", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dimensions, (dimension) => {
            return (_openBlock(), _createElementBlock("th", {
              key: dimension.id.value,
              class: _normalizeClass({
              'has-background-primary-light': dimension.isMeasureDimension,
              'has-text-weight-normal': !(dimension.isMeasureDimension || dimension.isKeyDimension),
            })
            }, [
              _createVNode(_component_cube_preview_dimension, {
                dimension: dimension,
                "selected-language": _ctx.selectedLanguage,
                "cube-uri": _ctx.cube.id.value
              }, null, 8, ["dimension", "selected-language", "cube-uri"])
            ], 2))
          }), 128)),
          (_ctx.dimensions.length === 0)
            ? (_openBlock(), _createElementBlock("th", _hoisted_11, " No dimensions defined "))
            : _createCommentVNode("", true)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: error.id.value
          }, [
            _createElementVNode("td", {
              colspan: _ctx.tableWidth,
              class: "p-0"
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("p", _hoisted_14, [
                  _createVNode(_component_o_icon, {
                    icon: "exclamation-triangle",
                    class: "mr-1"
                  }),
                  _createElementVNode("span", null, _toDisplayString(error.description), 1)
                ])
              ])
            ], 8, _hoisted_12)
          ]))
        }), 128))
      ]),
      _createElementVNode("tbody", null, [
        (_ctx.observations.isLoading)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
              _createElementVNode("td", {
                colspan: _ctx.tableWidth,
                class: "p-0"
              }, [
                _createVNode(_component_loading_block, {
                  class: "has-background-light is-size-2",
                  style: _normalizeStyle(`height: calc(38px * ${this.pageSize});`)
                }, null, 8, ["style"])
              ], 8, _hoisted_16)
            ]))
          : (_ctx.observations.error)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                _createElementVNode("td", { colspan: _ctx.tableWidth }, [
                  _createVNode(_component_b_message, { type: "is-danger" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.observations.error), 1)
                    ]),
                    _: 1
                  })
                ], 8, _hoisted_18)
              ]))
            : (_ctx.observations.data && _ctx.observations.data.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                  _createElementVNode("td", { colspan: _ctx.tableWidth }, _hoisted_22, 8, _hoisted_20)
                ]))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.observations.data, (observation) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: observation.id.value
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dimensions, (dimension) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: dimension.clientPath,
                        class: _normalizeClass(_ctx.dimensionClasses(dimension))
                      }, [
                        _createVNode(_component_cube_preview_value, {
                          value: observation[dimension.about.value],
                          "is-shared-term": !!dimension.sharedDimension,
                          "selected-language": _ctx.selectedLanguage,
                          "cube-uri": _ctx.cube.id.value
                        }, null, 8, ["value", "is-shared-term", "selected-language", "cube-uri"])
                      ], 2))
                    }), 128))
                  ]))
                }), 128))
      ]),
      _createElementVNode("tfoot", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", {
            colspan: _ctx.tableWidth,
            class: "has-background-light"
          }, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_o_tooltip, { label: "Previous page" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_o_button, {
                      "icon-left": "chevron-left",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.page = _ctx.page - 1)),
                      disabled: !_ctx.hasPreviousPage
                    }, null, 8, ["disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_o_tooltip, { label: "Next page" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_o_button, {
                      "icon-left": "chevron-right",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.page = _ctx.page + 1)),
                      disabled: !_ctx.hasNextPage
                    }, null, 8, ["disabled"])
                  ]),
                  _: 1
                }),
                _hoisted_26,
                _createVNode(_component_o_input, {
                  modelValue: _ctx.page,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.page) = $event)),
                  modelModifiers: { number: true },
                  type: "number",
                  min: "1",
                  max: _ctx.totalPages,
                  class: "is-inline-block w-20"
                }, null, 8, ["modelValue", "max"]),
                _createElementVNode("span", _hoisted_27, "of " + _toDisplayString(_ctx.totalPages), 1),
                _createElementVNode("span", _hoisted_28, " (" + _toDisplayString(_ctx.totalItems) + " observations) ", 1)
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_o_tooltip, { label: "Page size" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_o_select, {
                      modelValue: _ctx.pageSize,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pageSize) = $event)),
                      title: "Page size"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageSizes, (pageSizeOption) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: pageSizeOption,
                            "native-value": pageSizeOption
                          }, _toDisplayString(pageSizeOption), 9, _hoisted_30))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_o_tooltip, { label: "Refresh data" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_o_button, {
                      "icon-left": "sync",
                      onClick: _ctx.refreshData
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ])
            ])
          ], 8, _hoisted_23)
        ])
      ])
    ])
  ]))
}